export default __webpack_public_path__ + "static/media/import_projects_model.853a9f53.xlsx";